import {h, Component} from 'preact';
import {connect} from 'preact-redux'
import style from './style.scss'
import emitter from '/chat/src/postmessage/emitter';
import SystemModel from '/chat/src/redux/model/system/model'
import CancelImage from '/chat/src/components/SVGImages/Cancel'


class CloseButton extends Component {
    constructor(props){
        super(props);
        this._onClick = this._onClick.bind(this);

    }
    _onClick(){
        emitter.send('*', 'openState', false);
    }
    render(){
        if(this.props.isNormalView) return null;
        return (
            <div className={style.CloseButton} onClick={this._onClick}>
                <CancelImage color='white'/>
            </div>)
    }
}

export default connect((state) => {
    return {
        isNormalView: SystemModel.isNormalView(state)
    }
})(CloseButton);



// WEBPACK FOOTER //
// ./components/Buttons/CloseButton/index.js